/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListString } from '../models/api-response-list-string';
import { ApiResponseWebhookConfig } from '../models/api-response-webhook-config';
import { create } from '../fn/webhook-config-api/create';
import { Create$Params } from '../fn/webhook-config-api/create';
import { disable } from '../fn/webhook-config-api/disable';
import { Disable$Params } from '../fn/webhook-config-api/disable';
import { getByCompanyId } from '../fn/webhook-config-api/get-by-company-id';
import { GetByCompanyId$Params } from '../fn/webhook-config-api/get-by-company-id';
import { getByReference } from '../fn/webhook-config-api/get-by-reference';
import { GetByReference$Params } from '../fn/webhook-config-api/get-by-reference';
import { getMyConfig } from '../fn/webhook-config-api/get-my-config';
import { GetMyConfig$Params } from '../fn/webhook-config-api/get-my-config';
import { listAvailableEvents } from '../fn/webhook-config-api/list-available-events';
import { ListAvailableEvents$Params } from '../fn/webhook-config-api/list-available-events';
import { listAvailableProviders } from '../fn/webhook-config-api/list-available-providers';
import { ListAvailableProviders$Params } from '../fn/webhook-config-api/list-available-providers';
import { listAvailableScopes } from '../fn/webhook-config-api/list-available-scopes';
import { ListAvailableScopes$Params } from '../fn/webhook-config-api/list-available-scopes';
import { update } from '../fn/webhook-config-api/update';
import { Update$Params } from '../fn/webhook-config-api/update';

@Injectable({ providedIn: 'root' })
export class WebhookConfigApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `update()` */
  static readonly UpdatePath = '/v1/api/ui/webhook-config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `update()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  update$Response(params: Update$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseWebhookConfig>> {
    return update(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `update$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  update(params: Update$Params, context?: HttpContext): Observable<ApiResponseWebhookConfig> {
    return this.update$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseWebhookConfig>): ApiResponseWebhookConfig => r.body)
    );
  }

  /** Path part for operation `create()` */
  static readonly CreatePath = '/v1/api/ui/webhook-config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params: Create$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseWebhookConfig>> {
    return create(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params: Create$Params, context?: HttpContext): Observable<ApiResponseWebhookConfig> {
    return this.create$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseWebhookConfig>): ApiResponseWebhookConfig => r.body)
    );
  }

  /** Path part for operation `disable()` */
  static readonly DisablePath = '/v1/api/ui/webhook-config/{reference}/disable';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disable()` instead.
   *
   * This method doesn't expect any request body.
   */
  disable$Response(params: Disable$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseWebhookConfig>> {
    return disable(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `disable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disable(params: Disable$Params, context?: HttpContext): Observable<ApiResponseWebhookConfig> {
    return this.disable$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseWebhookConfig>): ApiResponseWebhookConfig => r.body)
    );
  }

  /** Path part for operation `getByReference()` */
  static readonly GetByReferencePath = '/v1/api/ui/webhook-config/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByReference$Response(params: GetByReference$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseWebhookConfig>> {
    return getByReference(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByReference(params: GetByReference$Params, context?: HttpContext): Observable<ApiResponseWebhookConfig> {
    return this.getByReference$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseWebhookConfig>): ApiResponseWebhookConfig => r.body)
    );
  }

  /** Path part for operation `listAvailableScopes()` */
  static readonly ListAvailableScopesPath = '/v1/api/ui/webhook-config/scopes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAvailableScopes()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAvailableScopes$Response(params: ListAvailableScopes$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListString>> {
    return listAvailableScopes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAvailableScopes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAvailableScopes(params: ListAvailableScopes$Params, context?: HttpContext): Observable<ApiResponseListString> {
    return this.listAvailableScopes$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListString>): ApiResponseListString => r.body)
    );
  }

  /** Path part for operation `listAvailableProviders()` */
  static readonly ListAvailableProvidersPath = '/v1/api/ui/webhook-config/providers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAvailableProviders()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAvailableProviders$Response(params: ListAvailableProviders$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListString>> {
    return listAvailableProviders(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAvailableProviders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAvailableProviders(params: ListAvailableProviders$Params, context?: HttpContext): Observable<ApiResponseListString> {
    return this.listAvailableProviders$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListString>): ApiResponseListString => r.body)
    );
  }

  /** Path part for operation `getMyConfig()` */
  static readonly GetMyConfigPath = '/v1/api/ui/webhook-config/my';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMyConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyConfig$Response(params: GetMyConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseWebhookConfig>> {
    return getMyConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMyConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyConfig(params: GetMyConfig$Params, context?: HttpContext): Observable<ApiResponseWebhookConfig> {
    return this.getMyConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseWebhookConfig>): ApiResponseWebhookConfig => r.body)
    );
  }

  /** Path part for operation `listAvailableEvents()` */
  static readonly ListAvailableEventsPath = '/v1/api/ui/webhook-config/events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAvailableEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAvailableEvents$Response(params: ListAvailableEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListString>> {
    return listAvailableEvents(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAvailableEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAvailableEvents(params: ListAvailableEvents$Params, context?: HttpContext): Observable<ApiResponseListString> {
    return this.listAvailableEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListString>): ApiResponseListString => r.body)
    );
  }

  /** Path part for operation `getByCompanyId()` */
  static readonly GetByCompanyIdPath = '/v1/api/ui/webhook-config/company/{companyId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByCompanyId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByCompanyId$Response(params: GetByCompanyId$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseWebhookConfig>> {
    return getByCompanyId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByCompanyId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByCompanyId(params: GetByCompanyId$Params, context?: HttpContext): Observable<ApiResponseWebhookConfig> {
    return this.getByCompanyId$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseWebhookConfig>): ApiResponseWebhookConfig => r.body)
    );
  }

}
